import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import { QQShare, WxLaunchHack } from 'ThreeTerminal_mobile';
import { h5PageCount } from 'ThreeTerminal_utils';
// import Grounds from 'ThreeTerminal_base/grounds';=
import { Grounds } from '@ifeng-fe/client_grounds';
import Loading from './loading';
import Banner from './banner';
import Map from './map';
import DataList from './dataList';
import Haibao from './haibao';
import ShareImg from './shareImg';
import { getVotesData, getQrcodeImage } from '../../../services/api';

class Layout extends React.PureComponent {  
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        loading: true,
        data: [],
        updateTime: '',
        mapReRender: false,
        winner: '',
        shareShow: false,
        shareConfig: {},
        pageVisible: true,
        qrcodeImage: ''
    };

    async componentDidMount() {
        const {
            content: { pagecofig },
        } = this.props;

        this.getQrcodeImageHandle();

        if (window?.grounds) {
            Grounds.pageStat({
                id: `special_ucms_${pagecofig.name}`,
                type: 'other',
                url: encodeURIComponent(location.href),
                ref: encodeURIComponent(document.referrer),
            });
        } else if (!location.href.includes('new.ifeng.com')) {
            h5PageCount([
                {
                    behavior: 'page',
                    type: 'topic',
                    other: {
                        id: `special_ucms_${pagecofig.name}`,
                        url: encodeURIComponent(location.href),
                        ref: encodeURIComponent(document.referrer),
                    },
                },
            ]);
        }

        document.addEventListener('visibilitychange', () => {
            this.setState({
                pageVisible: document.visibilityState === 'visible',
            });
        });
    }

    getQrcodeImageHandle = async () => {
        let shareUrl = location.href.replace('news.ifeng.com', 'ishare.ifeng.com');

        shareUrl = shareUrl.includes('http://172.30') ? 'https://i.ifeng.com' : shareUrl;
        const qrcodeImage = await getQrcodeImage(shareUrl);

        this.setState({
            qrcodeImage
        });
    };

    // 判断是否是微信
    isWeixin = () => {
        const ua = typeof navigator === 'object' ? navigator.userAgent : '';

        return ua.match(/MicroMessenger/gi);
    };

    // 判断是否是客户端
    isClient = () => {
        return window && typeof window.grounds !== 'undefined';
    };

    handleDataInit = async () => {
        let data = {};

        try {
            data = await getVotesData();

            this.setState({
                data: [...data.data],
                updateTime: data.updateTimeStr,
                shareConfig: data?.share || {},
            });
        } catch (e) {
            console.error(e);
        }

        this.updateTimer = setInterval(async () => {
            try {
                if (this.state.pageVisible) {
                    console.log('auto update =====');

                    const data = await getVotesData();

                    this.setState({
                        data: [...data.data],
                        updateTime: data.updateTimeStr,
                        shareConfig: data?.share || {},
                        mapReRender: true,
                    });
                }
            } catch (e) {
                console.error(e);
            }
        }, 120000);
    };

    handleMapReRender = async () => {
        const data = await getVotesData();

        this.setState({
            data: [...data.data],
            updateTime: data.updateTimeStr,
            shareConfig: data?.share || {},
            mapReRender: true,
        });
    };

    handleMapReRenderStop = () => {
        this.setState({
            mapReRender: false,
        });
    };

    handleLoadingHide = () => {
        this.setState({
            loading: false,
        });
    };

    handleShareShow = () => {
        document.querySelector('html').style.overflow = 'hidden';
        document.querySelector('body').style.overflow = 'hidden';

        this.setState({
            shareShow: true,
        });
    };

    handleMaskHide = e => {
        // e.stopPropagation();

        // if (e.target.id !== 'close') {
        //     return;
        // }

        document.querySelector('html').style.overflow = 'auto';
        document.querySelector('body').style.overflow = 'auto';

        this.setState({
            shareShow: false,
        });
    };

    render() {
        const { loading, data, updateTime, mapReRender, shareShow, qrcodeImage, shareConfig } = this.state;
        const {
            content,
            content: { pagecofig },
        } = this.props;
        const main = [
            '亚利桑那',
            '佐治亚',
            '密歇根',
            '北卡罗来纳',
            '内华达',
            '宾夕法尼亚',
            '威斯康星'
        ];
        const shareTitle = shareConfig.title;
        const shareThumbnail = shareConfig.thumb;
        const shareUrl = shareConfig.shareurl;
        const introduction = shareConfig.desc;
        const introDisplay = pagecofig.introDisplay;

        let title = shareTitle;

        if (data[0] && !introDisplay) {
            const { bidenNum, trumpNum, status } = data[0];

            title = `实时票数统计：哈里斯${bidenNum}票vs特朗普${trumpNum}票`;

            if (status === '已结束') {
                if (bidenNum >= 270) {
                    title = `实时票数统计：哈里斯${bidenNum}票获胜!`;
                }

                if (trumpNum >= 270) {
                    title = `实时票数统计：特朗普${trumpNum}票获胜!`;
                }
            }

            if (document.querySelector('#ifeng_share_url')) {
                document.querySelector('#ifeng_share_url').innerText = shareUrl;
            }

            if (document.querySelector('#ifeng_share_title')) {
                document.querySelector('#ifeng_share_title').innerText = title;
            }
        }

        const qqShareCofig = {
            title,
            img: shareThumbnail || 'https://p1.ifengimg.com/29b92e35b2b20708/2017/51/ifengLogo300x300.jpg',
            desc: introduction || '',
            cb: () => {
                console.log('分享成功');
            },
        };

        const wxLaunchHackData1 = {
            callAppConfig: {
                docType: 'web',
                pid: location.href,
                kind: 'inter_dsjzt02',
                noKindFrom: 1,
                download: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1473191753002',
                downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8820',
            },
            statisticsConfig: {
                behavior: 'action',
                type: 'us_election_dl',
                id: `special_ucms_${pagecofig.name}`,
                url: encodeURIComponent(location.href),
                ref: encodeURIComponent(document.referrer),
            },
        };

        const wxLaunchHackData2 = {
            callAppConfig: {
                docType: 'web',
                pid: 'https://news.ifeng.com/loc/timeline/event/8WO8D9UjAnJ?isFull=0&immersion=true&ifengsp=1',
                kind: 'inter_dsjzt02',
                noKindFrom: 1,
                download: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1473191753002',
                downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8820',
            },
            statisticsConfig: {
                behavior: 'action',
                type: 'us_election_dl',
                id: `special_ucms_${pagecofig.name}`,
                url: encodeURIComponent(location.href),
                ref: encodeURIComponent(document.referrer),
            },
        };

        return (
            <div className={styles.layout}>
                {data[0] && <QQShare content={qqShareCofig} />}
                <Loading handleLoadingHide={this.handleLoadingHide} handleDataInit={this.handleDataInit} />
                {data[0] && <Banner loading={loading} content={content} shareConfig={shareConfig} data={data[0]} wxLaunchHackData={wxLaunchHackData2} />}
                {data.length > 0 && (
                    <Map
                        mapReRender={mapReRender}
                        data={data.slice(1)}
                        updateTime={updateTime}
                        handleMapReRender={this.handleMapReRender}
                        handleMapReRenderStop={this.handleMapReRenderStop}
                    />
                )}
                <div className={styles.br} />
                {data.length > 0 && <DataList data={data} main={main} />}
                <div className={styles.bottom}>
                    <span />
                    {!this.isClient() && (
                        <span className={styles.download}>
                            立即下载
                            <WxLaunchHack content={wxLaunchHackData1} />
                        </span>
                    )}
                </div>
                <div className={styles.more} onClick={this.handleShareShow}>
                    <span />
                    <span className={styles.txt1}>分享实时票数</span>
                </div>
                {data.length > 0 && qrcodeImage && <ShareImg data={data} updateTime={updateTime} qrcodeImage={qrcodeImage} />}
                {shareShow && (
                    <Haibao handleMaskHide={this.handleMaskHide} />
                )}
            </div>
        );
    }
}

export default errorBoundary(Layout);
